// extracted by mini-css-extract-plugin
export default {"card":"card_card__TftKV","wide":"card_wide__o0PFd","border":"card_border__jcJWx","nopadding":"card_nopadding__dYAg-"};